module.exports = __webpack_public_path__ + "img/dirt-3.b91ba358.png";